import React, {useState} from "react";
import axios from "axios";
import "./Weather.css"
import WeatherOverview from "./WeatherOverview";
import Forecast from "./Forecast";
import CircleLoader from "react-spinners/CircleLoader";


export default function Weather(props) {
    const [weatherData, setWeatherData] = useState({ ready: false });
    const [city, setCity] = useState(props.currentCity);
  
    function handleResponse(response) {
        setWeatherData({
          ready: true,
          temperature: response.data.main.temp,
          humidity: response.data.main.humidity,
          date: new Date(response.data.dt * 1000),
          description: response.data.weather[0].description,
          icon: response.data.weather[0].icon,
          wind: response.data.wind.speed,
          city: response.data.name,
        });
    }

    function handleSubmit(event) {
      event.preventDefault();
      apiCall();
    }
  
    function handleCityChange(event) {
      setCity(event.target.value);
    }
  
    function apiCall() {
      const apiKey = "28db25b5b965562e80729db18525a71f";
      let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
      axios.get(apiUrl).then(handleResponse);
    }

    if (weatherData.ready) {
        return ( 
          <div className="Weather">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-9">
                  <input
                  type="search"
                  placeholder="Search for a city.."
                  className="form-control"
                  autoFocus="on"
                  onChange={handleCityChange}
                  />
                </div>
              <div className="col-3">
                <input
                type="submit"
                value="Search"
                className="btn btn-light"
                />
              </div>
            </div>
          </form> 
          <WeatherOverview data={weatherData} />
          <Forecast city={weatherData.city} />
        </div>
        );
      } else {
        apiCall();
        return (
            <div className="loading">
              <CircleLoader
                css="
                display: block;
                margin: 0 auto;
              "
                size={40}
                color={"#F95723"}
                loading={true}
              />
            </div>
          );
      }
  }
  